module.exports = {"130223001":"滦河街道","130223002":"古城街道","130223003":"滦城路街道","130223004":"响堂街道","130223102":"东安各庄镇","130223103":"雷庄镇","130223104":"茨榆坨镇","130223105":"榛子镇","130223106":"杨柳庄镇","130223107":"油榨镇","130223108":"古马镇","130223109":"小马庄镇","130223110":"九百户镇","130223111":"王店子镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130223.json
// module id = 88
// module chunks = 0